// This script serves the following purpose for the Input OTP components:
// - Auto-advance on input
// - Backspace to move backward
// - Pasting of full OTP

export const initInputOtp = () => {
  const otpWrappers = document.querySelectorAll('.otp-wrapper');

  otpWrappers.forEach((wrapper) => {
    const otpInputs = wrapper.querySelectorAll('.otp-input');

    otpInputs.forEach((input, index) => {
      // Auto move to next on input
      input.addEventListener('input', () => {
        const value = input.value;
        const isLastInput = index === otpInputs.length - 1;

        if (value.length > 1) {
          handlePaste(value);
          return;
        }

        if (value && !isLastInput) {
          otpInputs[index + 1].focus();
        }
      });

      // Move to previous on Backspace
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && input.value === '' && index > 0) {
          otpInputs[index - 1].focus();
        }
      });

      // Handle full OTP paste
      input.addEventListener('paste', (e) => {
        e.preventDefault();
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        handlePaste(paste);
      });
    });

    // Paste logic scoped to current wrapper
    function handlePaste(paste) {
      const cleaned = paste.replace(/\s+/g, '').substring(0, otpInputs.length);
      [...cleaned].forEach((char, i) => {
        otpInputs[i].value = char;
      });

      // Focus next empty field (or last)
      const firstEmpty = [...otpInputs].find((input) => input.value === '');
      if (firstEmpty) {
        firstEmpty.focus();
      } else {
        otpInputs[otpInputs.length - 1].focus();
      }
    }
  });
};
